import type { PylotFrontendConfig } from '../config.d'
export const config: PylotFrontendConfig = {
    is_fallback: false,
    base: {
        menu: { submenu: 'cms_block', submenu_maxitems: 10 },
        url: {
            baseUrl: 'https://www.casaideas.cl/',
            mediaBackend: {
                enabled: true,
                baseMediaUrl: 'https://headless.casaideas.cl/media/'
            },
            model: {
                category: { suffix: '', directory: 'categoria' },
                cmsPage: { suffix: '', directory: 'contenido' },
                product: { suffix: '', directory: 'producto' }
            },
            media: {
                cms: 'wysiwyg/social_media/cms',
                home: 'wysiwyg/social_media/home'
            },
            path: { shippingSettings: 'content/ordering-info' }
        },
        wishlist: {
            enabled: true,
            multiple_wishlists: false,
            multiple_wishlist_number: 20
        },
        route: { cms_no_route: 'no-route', cms_home_page: 'home-mg' },
        product: {
            visibleListAttributes: ['sku', 'price_range', 'small_image', 'name']
        },
        pwa: { download_enabled: false, visual_search_enabled: true },
        loqate: {
            enabled: false,
            findEndPoint:
                'https://api.addressy.com/Capture/Interactive/Find/v1.1/json3.ws',
            retrieveEndPoint:
                'https://api.addressy.com/Capture/Interactive/Retrieve/v1.2/json3.ws',
            validateEndPoint:
                'https://api.addressy.com/Cleansing/International/Batch/v1.00/json4.ws',
            api_key: ''
        },
        shipping: {
            addressCountry: ['AU, NZ, AL, DZ, EE, IR, IQ, AF'],
            includeShippingDetails: false
        },
        yotpo: { enabled: false, api_key: '' },
        customer: {
            gift_card_payment_enabled: true,
            store_credit_enabled: true
        }
    },
    static: {
        products: { count: 100 },
        categories: { count: 100, root: 'casaideas' }
    },
    preload: {
        menu: {
            variables: { category_uid: 'NA==', onlyTopLevel: true },
            queryPath:
                'framework/pylot/hooks/category/graphql/navigationMenuWithCMSBlocks.ts'
        },
        footer: {
            variables: {
                identifiers: [
                    'footer-copyright-block',
                    'footer_links',
                    'footer-social-media'
                ]
            },
            role: {
                copyright: 'footer-copyright-block',
                links: 'footer_links',
                social: 'footer-social-media'
            }
        }
    },
    seo: {
        default: {
            title: '',
            titleTemplate: 'Casaideas | %s',
            description: '',
            openGraph: {
                type: 'website',
                locale: 'en_US',
                url: 'https://www.casaideas.cl/',
                site_name: 'Casaideas',
                images: [
                    {
                        url: 'https://www.casaideas.cl/PylotSymbol.svg',
                        alt: 'Casaideas'
                    }
                ]
            },
            twitter: { handle: '', site: 'Casaideas', cardType: 'summary' }
        },
        product: {
            attributes: {
                name: ['name'],
                description: ['description', 'html'],
                image: ['media_gallery', '0', 'url'],
                price_amount: [
                    'price_range',
                    'minimum_price',
                    'final_price',
                    'value'
                ],
                price_currency: [
                    'price_range',
                    'minimum_price',
                    'final_price',
                    'currency'
                ],
                item_condition: null,
                gtin: ['gtin'],
                brand: ['brand'],
                manufacturer: ['manufacturer'],
                model: ['model'],
                sku: ['sku'],
                mpn: ['mpn'],
                seller: ['seller'],
                alternate_name: ['alternate_name'],
                review_count: ['review_count'],
                review_summary: ['review_summary']
            },
            description: {
                regExp: '^[\\n|\\n\\r]+Details[\\n|\\n\\r]+',
                maxLength: 1000
            },
            image: {
                count: 1,
                placeholder:
                    'https://headless.casaideas.cl/static/frontend/Magento/luma/en_US/Magento_Catalog/images/product/placeholder/image.jpg',
                width: 620
            },
            price: { currency: 'USD', precision: 2, validUntilDays: 14 },
            itemConditionMap: null,
            defaultBrand: 'Casaideas',
            defaultSeller: null,
            bestRating: 5
        },
        searchBox: {
            allowedPath: '/',
            potentialActions: [
                {
                    target: 'https://www.casaideas.cl/search?q',
                    queryInput: 'search_term_string'
                }
            ]
        },
        organization: {
            allowedPath: '/',
            content: {
                url: 'https://casaideas.cl/',
                logo: 'https://casaideas.cl/media/logo/stores/1/logo_casaideas_4x.png',
                name: 'Casaideas',
                email: 'serviciocliente@casaideas.com',
                address: {
                    streetAddress: 'Manuel Antonio Tocornal 356',
                    addressLocality: 'Santiago',
                    addressRegion: 'Región Metropolitana',
                    postalCode: '8330291',
                    '@type': 'PostalAddress',
                    addressCountry: 'Chile'
                },
                contactPoint: [
                    {
                        telephone: '+1 973 783 2783',
                        contactType: 'customer support',
                        contactOption: 'TollFree',
                        areaServed: 'CL',
                        availableLanguage: 'es'
                    }
                ],
                sameAs: [
                    'https://twitter.com/GoCorra',
                    'https://www.pinterest.cl/Casaideas_',
                    'https://www.instagram.com/casaideaschile',
                    'https://www.facebook.com/CasaideasChile'
                ],
                '@context': 'https://schema.org',
                '@type': 'Corporation',
                legalname: 'Casaideas',
                description:
                    'En Casaideas queremos alegrar y facilitar la vida de las personas con productos sustentables que sorprenden e inspiran. Pensando en los apasionados por la casa, hemos creado una amplia oferta de productos accesibles con diseño propio que buscan brindar belleza y funcionalidad en cada espacio del hogar',
                knowsLanguage: 'SP'
            }
        },
        tagManager: { gtm: { enabled: true, containerId: 'GTM-PPWBBS4' } },
        customPages: {
            account: {
                pageName: 'My Account',
                pageType: 'account',
                children: {
                    orders: {
                        pageName: 'My Account | Orders',
                        pageType: 'account-orders'
                    },
                    wishlist: {
                        pageName: 'My Account | Wishlist',
                        pageType: 'account-wishlist'
                    },
                    address: {
                        pageName: 'My Account | Address',
                        pageType: 'account-address'
                    },
                    'account-information': {
                        pageName: 'My Account | Account Information',
                        pageType: 'account-information'
                    },
                    'store-credit': {
                        pageName: 'My Account | Store Credit',
                        pageType: 'account-store-credit'
                    },
                    newsletter: {
                        pageName: 'My Account | Newsletter Subscription',
                        pageType: 'account-newsletter'
                    },
                    'gift-card': {
                        pageName: 'My Account | Gift Card',
                        pageType: 'account-gift-card'
                    }
                }
            },
            search: { pageName: 'Search page', pageType: 'searchresults' },
            checkout: { pageName: 'Checkout page', pageType: 'checkout' }
        },
        checkoutSteps: { cart: 1, shipping: 2, payment: 3 },
        multiStoreUrlParamCount: 0
    }
}
